import {Typography, TypographyProps} from "@material-ui/core"
import styled from 'styled-components';

interface AMsTypographyProps extends TypographyProps {
  text?: string;
  children?: React.ReactNode;
}

const AmsTypographyRef = styled(Typography)({
  variant: "body1",
}) as typeof Typography;

const AmsTypography = ({
  text,
  children,
  ...others
}: AMsTypographyProps) => {
  return (
    <>
      {text ? <AmsTypographyRef dangerouslySetInnerHTML={{ __html: text || '' }}  {...others} /> :
        <AmsTypographyRef   {...others} >{children} </AmsTypographyRef>
      }
    </>
  );
};

AmsTypography.defaultProps = {
  text: ''
}
export default AmsTypography;